import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { Button } from 'reactstrap';

import Constants from '../../../services/Constants';

export const OpenBackstopLink = (props) => {
  return (
    <Button
      className="text-nowrap crmLink"
      id="crmLink"
      tag="a"
      href={Constants.CRM_PLAN_URL.replace('{{planId}}', props.data.planId)}
      rel="noopener noreferrer"
      target="_blank">
      Go
    </Button>
  );
};

OpenBackstopLink.propTypes = {
  value: PropTypes.string,
  data: PropTypes.object,
  rowIndex: PropTypes.number,
};

export default connect(null, {})(OpenBackstopLink);
